export function spaceArchiveInit() {
	document.addEventListener( 'DOMContentLoaded', function() {
		// Don't run this script if not in correct archive page
		if ( ! document.querySelector( '.post-type-archive-space' ) ) {
			return;
		}

		const filterSelection = document.querySelector( '.archive-space-filter-selection' );

		const displayFilterSelection = () => {
		// Hide selection element if there are no filters selected
			if ( filterSelection.innerHTML.trim() === '' ) {
				filterSelection.classList.remove( 'active' );
			} else {
				filterSelection.classList.add( 'active' );
			}
		};

		const openAreaCounter = async ( el ) => {
			const hidden = el.target.ariaExpanded === 'true';
			document.querySelector( '.archive-space-areacounter' ).classList.toggle( 'active' );
			el.target.ariaExpanded = hidden ? 'false' : 'true';
			document.querySelector( '#areacounter-content' ).ariaHidden = hidden ? 'true' : 'false';

			if ( document.querySelector( '#areacounter-content' ).hidden === true ) {
				document.querySelector( '#areacounter-content' ).hidden = false;
			} else {
				document.querySelector( '#areacounter-content' ).hidden = true;
			}
		};

		document.querySelector( '#archive-space-areacounter-btn' ).addEventListener( 'click', openAreaCounter );

		const archiveDropDowns = document.querySelectorAll( '.archive-space-dropdown' );

		const countArea = ( el ) => {
			// Values for calculations
			const openOfficeVal = 17;
			const roomOfficeVal = 31;
			const combinationOfficeVal = 11.5;

			let openOfficeResult;
			let roomOfficeResult;
			let combinationOfficeResult;

			const personelAmount = document.querySelector( '#personel-amount' );
			const squareMeters = document.querySelector( '#square-meters-amount' );

			if ( el.target.id === 'personel-amount' ) {
				squareMeters.value = 0;

				const unit = ' m²';

				openOfficeResult = parseInt( personelAmount.value * openOfficeVal ) + unit;
				roomOfficeResult = parseInt( personelAmount.value * roomOfficeVal ) + unit;
				combinationOfficeResult = parseInt( personelAmount.value * combinationOfficeVal ) + unit;

				document.querySelector( '#areacounter-result-header' ).innerHTML = window.recommendedSpaceStr;
			} else {
				personelAmount.value = 0;

				openOfficeResult = parseInt( squareMeters.value / openOfficeVal );
				roomOfficeResult = parseInt( squareMeters.value / roomOfficeVal );
				combinationOfficeResult = parseInt( squareMeters.value / combinationOfficeVal );

				document.querySelector( '#areacounter-result-header' ).innerHTML = window.recommendedPersonnelStr;
			}

			document.querySelector( '#open-office' ).value = `${ openOfficeResult }`;
			document.querySelector( '#room-office' ).value = `${ roomOfficeResult }`;
			document.querySelector( '#combination-office' ).value = `${ combinationOfficeResult }`;
		};

		document.querySelector( '#personel-amount' ).addEventListener( 'input', countArea );
		document.querySelector( '#square-meters-amount' ).addEventListener( 'input', countArea );

		const mapParams = ( element ) => {
			if ( element.checked ) {
				return element.value;
			}
		};

		const resetForms = ( element ) => {
			if ( element.name === 'all' ) {
				element.disabled = true;
				element.checked = true;
			} else {
				element.checked = false;
			}
			document.getElementsByClassName( 'archive-space-misc-show-list' )[ 0 ].click();
		};

		const fetchData = async () => {
			document.querySelector( '.archive-space-items-overlay' ).classList.add( 'active' );

			const types = [ ...document.querySelectorAll( '[data-term="space-type"]' ) ].filter( ( item ) => item.checked && item.value !== '' ).map( mapParams );
			const locations = [ ...document.querySelectorAll( '[data-term="space-location"]' ) ].filter( ( item ) => item.checked && item.value !== '' ).map( mapParams );
			const squareMeters = [ ...document.querySelectorAll( '[data-term="space-square-metres"]' ) ].filter( ( item ) => item.checked && item.value !== '' ).map( mapParams );

			const groupByPremise = document.getElementById( 'group-spaces' ).checked;

			const paramType = types.length > 0 ? `space_type=${ types.join( ',' ) }` : '';
			const paramLocation = locations.length > 0 ? `space_location=${ locations.join( ',' ) }` : '';
			const paramSquareMeters = squareMeters.length > 0 ? `space_square_metres=${ squareMeters.join( ',' ) }` : '';
			const paramGroupByPremise = groupByPremise === true ? `group=true` : '';

			const lang = document.getElementsByTagName( 'html' )[ 0 ].attributes.lang.value;

			const paramLang = `space_lang=${ lang }`;

			const params = `${ [ paramType, paramLocation, paramSquareMeters, paramGroupByPremise, paramLang ].filter( Boolean ).join( '&' ) }`;

			const fetchUrl = `${ window.location.origin }/wp-json/wp-exove/v2/space/${ params !== '' ? '?' + params : '' }`;

			await fetch( fetchUrl )
				.then( ( res ) => {
					return res.json();
				} )
				.then( ( data ) => {
					document.querySelector( '#archive-space-list' ).innerHTML = data.html;
					document.querySelector( '#spaces-count' ).innerHTML = document.querySelector( '.archive-space-items-container' ).dataset.count;
					document.querySelector( '#spaces-count + span' ).innerHTML = document.querySelector( '.archive-space-misc-count' ).dataset[ groupByPremise ? 'premiseLabel' : 'spaceLabel' ];
				} )
				.finally( () => {
					document.querySelector( '.archive-space-items-overlay' ).classList.remove( 'active' );
				} );

			const slugUrl = lang !== 'fi' ? `/${ lang.split( '-' )[ 0 ] }/${ window.postType }/` : `/${ window.postType }/`;
			const newUrl = window.location.protocol + '//' + window.location.host + slugUrl + ( params !== '' ? '?' + params : '' );
			window.history.pushState( { path: newUrl }, document.title, newUrl );
			window.dispatchEvent( new Event( 'popstate' ) );
		};

		const onInputChange = ( el ) => {
			if ( el.target.id.startsWith( 'all' ) ) {
				if ( el.target.checked ) {
					el.target.disabled = true;
				}

				document.querySelectorAll( `[data-term="${ el.target.dataset.term }"]` ).forEach( ( item ) => {
					if ( item.id !== `all-${ el.target.dataset.term }` && item.checked ) {
						item.checked = false;

						// Add extra letter for square meter slug to prevent ID syntax error
						const newValue = el.target.dataset.term === 'space-square-metres' ? 'a' + item.value : item.value;

						document.querySelector( `#filter-selection-${ newValue }` ).remove();
					}
				} );
			} else if ( [ ...document.querySelectorAll( `[data-term="${ el.target.dataset.term }"]` ) ].filter( ( item ) => item.id !== `#all-${ el.target.dataset.term }` ).every( ( item ) => ! item.checked ) ) {
				document.querySelector( `#all-${ el.target.dataset.term }` ).checked = true;
			} else {
				document.querySelector( `#all-${ el.target.dataset.term }` ).checked = false;
				document.querySelector( `#all-${ el.target.dataset.term }` ).disabled = false;
			}

			// Add extra letter for square meter slug to prevent ID syntax error
			const newValue = el.target.dataset.term === 'space-square-metres' ? 'a' + el.target.value : el.target.value;

			if ( ! el.target.id.startsWith( 'all' ) ) {
				if ( el.target.checked ) {
					let newSelection = `<div id="filter-selection-${ newValue }" class="archive-space-filter-selection-item">`;
					newSelection +=	`<span>${ el.target.name }</span>`;
					newSelection += `<button data-for="${ newValue }" class="remove-selection-btn"><img src="${ window.icon }" alt="${ window.selectionLang }"></button></div>`;
					const newElement = document.createElement( 'div' );
					newElement.innerHTML = newSelection;
					newElement.firstChild.querySelector( 'button' ).onclick = removeFilterSeletion;
					filterSelection.append( newElement.firstChild );
				} else {
					document.querySelector( `#filter-selection-${ newValue }` ).remove();
				}
			}

			displayFilterSelection();
			fetchData();
		};

		document.getElementById( 'space-type' ).addEventListener( 'change', onInputChange );
		document.getElementById( 'space-location' ).addEventListener( 'change', onInputChange );
		document.getElementById( 'space-square-metres' ).addEventListener( 'change', onInputChange );
		document.getElementById( 'group-spaces' ).addEventListener( 'change', ( () => {
			document.getElementsByClassName( 'archive-space-misc-show-list' )[ 0 ].click(); fetchData();
		} ) );

		const closeDropdowns = () => {
			archiveDropDowns.forEach( ( dropdown ) => {
				dropdown.classList.remove( 'open' );
			} );
		};

		const clearFilters = () => {
			document.querySelectorAll( '[data-term="space-type"]' ).forEach( resetForms );
			document.querySelectorAll( '[data-term="space-location"]' ).forEach( resetForms );
			document.querySelectorAll( '[data-term="space-square-metres"]' ).forEach( resetForms );
			document.querySelectorAll( '.archive-space-dropdown span[data-units]' ).forEach( ( span ) => {
				span.textContent = '';
			} );
			filterSelection.innerHTML = '';
			document.getElementById( 'group-spaces' ).checked = false;
		};

		archiveDropDowns.forEach( ( dropdown ) => {
			const toggleButton = dropdown.querySelector( 'button' );
			const toggleButtonSpan = toggleButton.querySelector( 'span[data-units]' );
			const dropdownItemsSelector = '.archive-space-dropdown-item input[type="checkbox"]';
			const dropdownItems = dropdown.querySelectorAll( dropdownItemsSelector );
			const dropdownClose = dropdown.querySelector( '.archive-space-dropdown-close' );

			// Update initial selected count
			const initialSelectedCount = dropdown.querySelectorAll( `${ dropdownItemsSelector }:not([name="all"]):checked` ).length;
			if ( initialSelectedCount === 0 ) {
				toggleButtonSpan.textContent = '';
			} else {
				toggleButtonSpan.textContent = `${ initialSelectedCount } ${ toggleButtonSpan.dataset.units }`;
			}

			// Update selected count on click
			dropdownItems.forEach( ( item ) => {
				item.addEventListener( 'click', () => {
					const selectedCount = dropdown.querySelectorAll( `${ dropdownItemsSelector }:not([name="all"]):checked` ).length;
					if ( selectedCount === 0 || item.name === 'all' ) {
						toggleButtonSpan.textContent = '';
					} else {
						toggleButtonSpan.textContent = `${ selectedCount } ${ toggleButtonSpan.dataset.units }`;
					}
				} );
			} );

			// Close dropdown on close button click
			dropdownClose.addEventListener( 'click', ( e ) => {
				dropdown.classList.remove( 'open' );
				toggleButton.setAttribute( 'aria-expanded', 'false' );
				e.stopPropagation();
			} );

			dropdown.querySelector( 'button' ).onclick = function( e ) {
				if ( ! dropdown.classList.contains( 'open' ) ) {
					closeDropdowns();
					dropdown.classList.add( 'open' );
					dropdown.querySelector( '.archive-space-dropdown-label' ).setAttribute( 'aria-expanded', 'true' );
				} else {
					dropdown.classList.remove( 'open' );
					dropdown.querySelector( '.archive-space-dropdown-label' ).setAttribute( 'aria-expanded', 'false' );
				}
				e.stopPropagation();
			};
			dropdown.onclick = function( e ) {
				dropdown.classList.add( 'open' );
				dropdown.querySelector( '.archive-space-dropdown-label' ).setAttribute( 'aria-expanded', 'true' );
				e.stopPropagation();
			};
		} );

		document.onclick = function() {
			closeDropdowns();
		};

		document.querySelector( '#search-clear' ).onclick = function() {
			clearFilters();
			displayFilterSelection();
			fetchData();
		};

		document.querySelector( '.archive-space-misc-show-list' ).onclick = function( el ) {
			if ( ! el.target.classList.contains( 'active' ) ) {
				el.target.classList.add( 'active' );
				document.querySelector( '.archive-space-misc-show-map' ).classList.remove( 'active' );

				document.querySelector( '#archive-space-list' ).classList.add( 'show' );
				document.querySelector( '.archive-space-misc-show-list' ).ariaSelected = true;
				document.querySelector( '#archive-space-map' ).classList.remove( 'show' );
				document.querySelector( '.archive-space-misc-show-map' ).ariaSelected = false;
			}
		};
		document.querySelector( '.archive-space-misc-show-map' ).onclick = function( el ) {
			if ( ! el.target.classList.contains( 'active' ) ) {
				const groupBox = document.getElementById( 'group-spaces' );
				if ( ! groupBox.checked ) {
					groupBox.click();
				}
				el.target.classList.add( 'active' );
				document.querySelector( '.archive-space-misc-show-list' ).classList.remove( 'active' );
				document.querySelector( '.archive-space-misc-show-list' ).ariaSelected = false;
				document.querySelector( '#archive-space-list' ).classList.remove( 'show' );
				document.querySelector( '#archive-space-map' ).classList.add( 'show' );
				document.querySelector( '.archive-space-misc-show-map' ).ariaSelected = true;
			}
		};

		const removeFilterSeletion = ( e ) => {
			const selection = e.target.dataset.for;
			document.querySelector( `#filter-selection-${ selection }` ).remove();

			const input = document.querySelector( `#${ selection }` );
			input.checked = false;

			if ( [ ...document.querySelectorAll( `[data-term="${ input.dataset.term }"]` ) ].filter( ( item ) => item.id !== `#all-${ input.dataset.term }` ).every( ( item ) => ! item.checked ) ) {
				document.querySelector( `#all-${ input.dataset.term }` ).checked = true;
				document.querySelector( `#all-${ input.dataset.term }` ).disabled = true;
			}

			document.querySelectorAll( `.archive-space-dropdown` ).forEach( ( dropdown ) => {
				if ( dropdown.querySelector( `#${ selection }` ) ) {
					const dropdownItemsSelector = '.archive-space-dropdown-item input[type="checkbox"]';
					const toggleButtonSpan = dropdown.querySelector( 'button' ).querySelector( 'span[data-units]' );
					const selectedCount = dropdown.querySelectorAll( `${ dropdownItemsSelector }:not([name="all"]):checked` ).length;
					if ( selectedCount === 0 ) {
						toggleButtonSpan.textContent = '';
					} else {
						toggleButtonSpan.textContent = `${ selectedCount } ${ toggleButtonSpan.dataset.units }`;
					}
				}
			} );

			displayFilterSelection();
			fetchData();
		};

		document.querySelectorAll( '.remove-selection-btn' ).forEach( ( btn ) => {
			btn.onclick = removeFilterSeletion;
		} );

		const listViewButton = document.getElementById( 'archive-space-misc-show-list' );
		const mapViewButton = document.getElementById( 'archive-space-misc-show-map' );

		// Get all links from List view tab content area.
		let tabContentLinksListView = document.getElementById( 'archive-space-list' ).getElementsByTagName( 'a' );
		// Get first link from List viewtab content area.
		let firstLinkListView = tabContentLinksListView[ '0' ];

		listViewButton.addEventListener( 'keydown', function( e ) {
			tabContentLinksListView = document.getElementById( 'archive-space-list' ).getElementsByTagName( 'a' );
			firstLinkListView = tabContentLinksListView[ '0' ];

			if ( e.key === 'ArrowRight' || e.key === 'ArrowLeft' ) {
				mapViewButton.focus();
			}

			if ( e.key === 'Tab' ) {
				// For some reason without timeout focus goes to second link.
				setTimeout( () => {
					firstLinkListView.focus();

					// Back to listview tab button.
					// eslint-disable-next-line no-shadow
					firstLinkListView.addEventListener( 'keydown', function( e ) {
						if ( e.shiftKey && e.key === 'Tab' ) {
							setTimeout( () => {
								listViewButton.focus();
							} );
						}
					} );
				}, '10' );
			}

			// Focus back to previous checkbox.
			if ( e.shiftKey && e.key === 'Tab' ) {
				setTimeout( () => {
					document.getElementById( 'group-spaces' ).focus();
				}, '10' );
			}
		} );

		mapViewButton.addEventListener( 'keydown', function( e ) {
			// Get all links from tab content area.
			const tabContentLinksMapView = document.getElementById( 'archive-space-map' ).getElementsByTagName( 'a' );

			// Get first link from tab content area.
			const firstLinkMapView = tabContentLinksMapView[ '0' ];

			if ( e.key === 'ArrowLeft' || e.key === 'ArrowRight' ) {
				e.preventDefault();
				listViewButton.focus();
			}

			if ( firstLinkMapView ) {
				if ( e.key === 'Tab' ) {
					setTimeout( () => {
						firstLinkMapView.focus();
					}, '10' );
				}
			}

			// Focus back to previous checkbox.
			if ( e.shiftKey && e.key === 'Tab' ) {
				setTimeout( () => {
					document.getElementById( 'group-spaces' ).focus();
				}, '10' );
			}
		} );
	} );
}
